module.exports = __webpack_public_path__ + "media/day/395-65624b92.svg";